import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    courseList:[]
  },
  mutations: {
    createCourseList(state, info) {
      state.courseList = info
    },
    
  },
  getters:{
    getCourseList(state) {
      return state.courseList
    },
    
  },
  actions: {

  },
  modules: {
  },
})
